document.addEventListener('DOMContentLoaded', () => {
  const injectedClass = 'frcp-loyalty-consent-injected'
  const checkboxSelector = '.frcp-loyalty-consent__input'

  const consentText = window.frcpLoyaltyStrings?.consentHtml || ''

  const consentMarkup = `
    <div class="frcp-loyalty-consent newsletter-form__agreements">
      <div class="newsletter-form__agreements-wrapper">
        <div class="checkbox-wrapper">
          <input type="checkbox" id="FrcpLoyaltyConsent" class="frcp-loyalty-consent__input">
        </div>
        <label for="FrcpLoyaltyConsent" class="newsletter-form__agreement">${consentText}</label>
      </div>
    </div>
  `

  const updateWidgetState = (checkbox) => {
    const widget = checkbox.closest('.frcp-loyalty-widget')
    if (widget) {
      widget.classList.toggle('frcp-loyalty-consent--unchecked', !checkbox.checked)
    }
  }

  const injectConsentCheckbox = (welcomeCard) => {
    if (welcomeCard.classList.contains(injectedClass)) return
    welcomeCard.classList.add(injectedClass)

    const signInButtons = welcomeCard.querySelector('.frcp-sign-in-buttons')
    if (!signInButtons) return

    signInButtons.insertAdjacentHTML('beforebegin', consentMarkup)

    const checkbox = welcomeCard.querySelector(checkboxSelector)
    if (checkbox) {
      checkbox.addEventListener('change', () => updateWidgetState(checkbox))
      updateWidgetState(checkbox)
    }
  }

  const scanForWelcomeCards = () => {
    document.querySelectorAll('.frcp-welcome').forEach(injectConsentCheckbox)
  }

  scanForWelcomeCards()

  const observer = new MutationObserver(() => scanForWelcomeCards())
  observer.observe(document.body, { childList: true, subtree: true })

  document.addEventListener('click', (event) => {
    const joinLink = event.target.closest('.frcp-loyalty-widget a.frcp-sign-in-btn')
    if (!joinLink) return

    const checkbox = document.querySelector(checkboxSelector)
    if (checkbox && !checkbox.checked) {
      event.preventDefault()
      event.stopPropagation()
      checkbox.closest('.frcp-loyalty-consent')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      checkbox.focus()
    }
  }, true)
})
